/**********************************

Cookie functions

***********************************/
//Sets a cookie with the given name and value for the current session.
function setSessionCookie(name, value) {
  let date = new Date();
  document.cookie = name + "=" + value + "; " + "; path=/";
}
//Gets a cookie with the given name.
function getSessionCookie(name) {
  const nameKey = name + "=";
  const cDecoded = decodeURIComponent(document.cookie);
  const cArr = cDecoded.split("; ");
  let res;
  cArr.forEach((val) => {
    if (val.indexOf(nameKey) === 0) res = val.substring(nameKey.length);
  });
  return res;
}

/***********************************/

// Start IPStack Geotargeting based on customers zipcode //

function getCookie(e) {
  return document.cookie.length > 0 &&
    ((c_start = document.cookie.indexOf(e + "=")), -1 != c_start)
    ? ((c_start = c_start + e.length + 1),
      (c_end = document.cookie.indexOf(";", c_start)),
      -1 == c_end && (c_end = document.cookie.length),
      unescape(document.cookie.substring(c_start, c_end)))
    : "";
}
function setCookie(e, t, c) {
  var o;
  if (c) {
    var n = new Date();
    n.setTime(n.getTime() + 24 * c * 60 * 60 * 1e3),
      (o = "; expires=" + n.toGMTString());
  } else o = "";
  document.cookie = e + "=" + t + o + "; path=/";
}
var zipcode = getCookie("zipcode");
var access_key = "9da7c901697562382ec847a53ec9dd4e";
if (zipcode == "") {
  $.ajax({
    url: "https://api.ipstack.com/check" + "?access_key=" + access_key,
    dataType: "jsonp",
    success: function (json) {
      // console.log(json);
      // alert(json.zip);
      if (json.zip) setCookie("zipcode", json.zip, 5);
    },
  });
} else {
  console.log("geotargeting working");
}

// End IPStack Geotargeting based on customers zipcode //

/**********************************

Product Inventory functions

***********************************/

const OutOfStockAlwaysSellStatusDisplay = "Usually ships within  1-2 weeks";

const InStockAlwaysSellStatusDisplay = "In Stock" +"</br>" +"<div id='cta_order_by'> For your area - Arrives <strong class='arrival_month'><span></span></strong></div>";

//Gets product inventory JSON data from shop.worldpantry.com and calls the given setProductInventoryStatus function
function getProductInventoryDisplay(
  zip,
  productId,
  variantId,
  setProductInventoryStatus
) {
  var url =
    "https://shop.worldpantry.com/productinventories/thinkproducts/productinventory.aspx";
  var postproductinventory = $.post(url, {
    zip: zip,
    key: "wp_2023_thinkproducts",
    productid: productId,
    variantid: variantId,
  });
  postproductinventory.done(function (data) {
    if (data) {
      if (data.Status == "OutOfStock") {
        data.StatusDisplay = OutOfStockAlwaysSellStatusDisplay;
      }
      setProductInventoryStatus(data);
    }
  });
}

//Gets WorldPantry product number and varaint number for each item in the current cart.
function getProductNumbers() {
  var productNumbers;
  $.ajax({
    type: "GET",
    url: "/cart?view=wp-productnumbers",
    async: false, //TODO: Ideally this should be done in async.
  }).done(function (response) {
    productNumbers = JSON.parse(response);
  });
  return productNumbers;
}

//Gets product inventories for the given list of WorldPantry product number and varaiant number.
function getProductInventories(productNumbers) {
  var items = [];
  var productInventories;
  for (i = 0; i < productNumbers.length; i++) {
    let item = {};
    item["productId"] = productNumbers[i].productNumber;
    item["variantId"] = productNumbers[i].variantNumber;
    items.push(item);
  }

  if (items) {
    var shippingInfo = new Object();
    shippingInfo.zip = getCookie("zipcode");
    shippingInfo.items = items;
    var url =
      "https://shop.worldpantry.com/productinventories/thinkproducts/productinventories.aspx";
    $.ajax({
      type: "POST",
      url: url,
      data: {
        key: "wp_2023_thinkproducts",
        shippingInfo: JSON.stringify(shippingInfo),
      },
      async: false, //TODO: Ideally this shoud be done in async.
    }).done(function (data) {
      productInventories = data;
    });
  }
  return productInventories;
}

//Gets a boolean value indicating if the product inventory status display needs to be displayed in the cart.
function showProductInventoryCartStatusDisplay(productInventories) {
  var showInventoryCartStatusDisplay = false;
  if (productInventories) {
    for (i = 0; i < productInventories.length; i++) {
      if (productInventories[i].Status == "OutOfStock") {
        showInventoryCartStatusDisplay = true;
        break;
      }
    }
  }
  return showInventoryCartStatusDisplay;
}

//Gets a product inventory for the given item ID.
function getProductInventory(id, productNumbers, productInventories) {
  var inventoryStatus;
  for (n = 0; n < productNumbers.length; n++) {
    if (productNumbers[n].id == id) {
      var productNumber = productNumbers[n].productNumber;
      var variantNumber = productNumbers[n].variantNumber;
      for (i = 0; i < productInventories.length; i++) {
        if (
          productInventories[i].ProductId.toUpperCase() ==
            productNumber.toUpperCase() &&
          productInventories[i].VariantId.toUpperCase() ==
            variantNumber.toUpperCase()
        ) {
          inventoryStatus = productInventories[i];
          if (inventoryStatus.Status == "OutOfStock") {
            inventoryStatus.StatusDisplay = OutOfStockAlwaysSellStatusDisplay;
          } else {
            inventoryStatus.StatusDisplay = InStockAlwaysSellStatusDisplay;
          }
          break;
        }
      }
      break;
    }
  }
  return inventoryStatus;
}
